import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["render", "children"],
  _excluded2 = ["fields", "values"];
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formContext } from "./formContext";

/** PureComponent that consumes all `Form` state and actions.
 * Used by `FormField` and `FormActions`.
 * Useful if you need to base the state of one or more fields on
 * the values of other fields in the `Form` */
class FormSpy extends PureComponent {
  constructor(props) {
    super(props);
    this.getFieldProps = () => {
      const _this$props = this.props,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
      const _this$context = this.context,
        {
          fields,
          values
        } = _this$context,
        formState = _objectWithoutPropertiesLoose(_this$context, _excluded2);
      return _extends({}, rest, formState, {
        fields: this.spy ? this.spy.reduce((obj, name) => _extends({}, obj, {
          [name]: fields[name] || {}
        }), {}) : fields,
        values: this.spy ? this.spy.reduce((obj, name) => _extends({}, obj, {
          [name]: values[name]
        }), {}) : values
      });
    };
    this.spy = props.fields;
  }
  render() {
    const {
      children,
      render
    } = this.props;
    return (children || render)(this.getFieldProps());
  }
}
FormSpy.contextType = formContext;
FormSpy.propTypes = {
  /**
   * Render `function`
   *
   * **Parameter** - `object` with the following items:
   *   - **fields:** The full state objects for each field named in the `fields` prop.
   *   - **hasErrors:** `true` if the `Form` contains any fields in error state.
   *   - **onUpdate:** `function` to be used when you need to update the state of any single field.
   *   - **reset:** `function` that resets the Form to its initial state.
   *   - **values:** `object` conaining only the values for the fields named in the `fields` prop.
   *
   *  `children` will be ignored if `render` is passed
   */
  children: PropTypes.func,
  /** Render `function`, same as `children`. */
  render: PropTypes.func,
  /** Array of names for the fields you want to spy on. If undefined, all fields will be returned */
  fields: PropTypes.arrayOf(PropTypes.string)
};
export { FormSpy };